import { render, staticRenderFns } from "./ModalContestacaoMedica.vue?vue&type=template&id=4edaf8c1&scoped=true"
import script from "./ModalContestacaoMedica.vue?vue&type=script&lang=ts"
export * from "./ModalContestacaoMedica.vue?vue&type=script&lang=ts"
import style0 from "./ModalContestacaoMedica.vue?vue&type=style&index=0&id=4edaf8c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edaf8c1",
  null
  
)

export default component.exports